<template>
  <v-list-item-group>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
    <v-skeleton-loader class="my-3" type="button"></v-skeleton-loader>
  </v-list-item-group>
</template>

<script>
export default {}
</script>

<style></style>
